import { Base, withBreakpointObserver } from '@studiometa/js-toolkit';
import Swiper from 'swiper';
import { Pagination, Autoplay } from 'swiper/modules';

/**
 * Slider component
 */
export default class ReassuranceHeroSlider extends withBreakpointObserver(Base) {
  /**
   * Component Configuration
   */
  static config = {
    name: 'ReassuranceHeroSlider',
    refs: ['slider', 'prev', 'next', 'pagination'],
    options: {
      activeBreakpoints: {
        type: String,
        default: 'xxs xs s',
      },
    },
  };

  /**
   *
   */
  mounted() {
    this.slider = new Swiper(this.$refs.slider, {
      modules: [Pagination, Autoplay],
      slidesPerView: 1,
      grabCursor: true,
      autoplay: {
        delay: 4000,
      },
      pagination: {
        clickable: true,
        el: this.$refs.pagination,
      },
    });
  }
}
